import type { components } from '@fluencelabs/vodopad-admin-api'
import { useCustom } from '@refinedev/core'

import { VODOPAD_ENDPOINT } from '@/constants/constants'
import { ensureArray } from '@/types/api'

type BasicUserGroupDto = components['schemas']['BasicUserGroupDto']

interface PaginatedResponse {
  items?: BasicUserGroupDto[]
}

export function useUserGroups() {
  const query = useCustom<PaginatedResponse | BasicUserGroupDto[]>({
    url: `${VODOPAD_ENDPOINT}/v1/admin/user_groups`,
    method: 'get',
    config: { query: { perPage: 100 } },
    queryOptions: { staleTime: 10 * 60 * 1000 },
  })

  const data = query.query.data?.data
  if (Array.isArray(data)) return data
  return ensureArray<BasicUserGroupDto>((data as PaginatedResponse)?.items)
}
